import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";

const faqs = [
  {
    q: "How much does a website really cost?",
    a: "Our one-time packages start at $299 CAD for a polished single-page site. Most micro businesses choose the $599 Growth package. No hidden fees — you'll get a clear quote before we begin.",
  },
  {
    q: "How long does it take to launch?",
    a: "Most projects go live within 7–14 days once we have your content. Simple Starter sites can be ready in under a week.",
  },
  {
    q: "Do I need to be technical?",
    a: "Not at all. That's exactly who we build for. We handle the domains, hosting, design and setup, and explain everything in plain language.",
  },
  {
    q: "Will my site work on phones?",
    a: "Always. Every site we build is mobile-first and looks great on phones, tablets and desktops.",
  },
  {
    q: "What about after launch?",
    a: "You can take it from there, or join an optional care plan from $75/mo for hosting, updates and support whenever you need us.",
  },
];

export default function FAQ() {
  return (
    <section id="faq" className="bg-[#F0F5F2] py-24 sm:py-32">
      <div className="mx-auto max-w-3xl px-6 sm:px-12">
        <div className="text-center">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#75C69F]">
            FAQ
          </span>
          <h2 className="mt-4 font-heading text-4xl font-medium tracking-tight text-[#0B281B] sm:text-5xl">
            Questions, answered.
          </h2>
        </div>

        <Accordion type="single" collapsible className="mt-12" data-testid="faq-accordion">
          {faqs.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              data-testid={`faq-item-${i}`}
              className="border-b border-[#DCECE3]"
            >
              <AccordionTrigger className="text-left font-heading text-lg font-medium text-[#0B281B] hover:no-underline">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-[#4A6657]">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
